"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedStaffOnline =
/*#__PURE__*/
function (_pb_1$StaffOnline) {
  _inherits(ExtendedStaffOnline, _pb_1$StaffOnline);

  function ExtendedStaffOnline(properties) {
    var _this;

    _classCallCheck(this, ExtendedStaffOnline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedStaffOnline).call(this, properties));
    _this.type = ExtendedStaffOnline.type;
    return _this;
  }

  _createClass(ExtendedStaffOnline, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.staff).concat(ExtendedStaffOnline.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.StaffOnline.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      mqttMessage.retained = true;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedStaffOnline(pb_1.StaffOnline.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedStaffOnline;
}(pb_1.StaffOnline);

ExtendedStaffOnline.type = "StaffOnline";
ExtendedStaffOnline.context = "/online";
exports.StaffOnline = ExtendedStaffOnline;